import axios from "axios";
import store from '@/store'

import router from '@/router/index'

import JSONBig from 'json-bigint'

const request = axios.create({
  // baseURL: 'http://192.168.1.88:8082',
  //baseURL: 'http://b.yaojingsupply.com',
  timeout: 60000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' },
  transformResponse: [function (data) {
    try {
      return JSONBig.parse(data)
    } catch (e) {
      return data
    }
  }]
})

if (process.env.VUE_APP_ENV === 'development') { // 开发环境 - 编译
    axios.defaults.baseURL = 'http://192.168.71.2:8082';
    // axios.defaults.baseURL = 'http://b.yaojingsupply.com';
}
if (process.env.VUE_APP_ENV === 'production') { // 生产环境 - 打包
    axios.defaults.baseURL = 'http://b.yaojingsupply.com';
}


request.interceptors.request.use(function (config) {

  // console.log('store.state.user.token',store.state.user.token)
  if (store.state.user.token) {
    config.headers['Authorization'] = store.state.user.token
  }
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

request.interceptors.response.use(function (response) {
  //对响应数据做点什么
  if (response.data.code === 401) {
    router.push({ name: 'login' })
  }  
  return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default request